import { Component, ChangeDetectionStrategy } from '@angular/core';

import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { SharedModule } from '../../../@commons/ui-components/shared.module';
import { BaseToastComponent } from '../../../@commons/ui-components/toast-popup/base-toast-component';
import RoutesConstants from '../../../@commons/constants/routes.constants';
import { ScanBarcodeIconComponent } from '../../../@icons/scan-barcode-icon.component';
import { SearchIconComponent } from '../../../@icons/search-icon.component';
import { ChevronRightIconComponent } from '../../../@icons/chevron-right.component';

/**
 * Feuille « Ajouter des graines » (maquette 09) : une feuille, deux chemins.
 * Ouverte par le « + » de Mon potager sur l'onglet Mes graines, et par le
 * bouton « Ajouter des graines » en tête de la liste.
 */
@Component({
  selector: 'vw-seed-actions-toast',
  imports: [SharedModule, TranslatePipe, ScanBarcodeIconComponent, SearchIconComponent, ChevronRightIconComponent],
  templateUrl: './seed-actions-toast.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SeedActionsToastComponent extends BaseToastComponent {
  constructor(private router: Router) {
    super();
  }

  scan(): void {
    this.onClose();
    this.router.navigate([RoutesConstants.USER_ADD_SEED_SCAN]);
  }

  searchCatalog(): void {
    this.onClose();
    this.router.navigate([RoutesConstants.USER_ADD_SEED_SELECT]);
  }
}
